import { render, staticRenderFns } from "./CobrancaList.vue?vue&type=template&id=46d2bb18&scoped=true&"
import script from "./CobrancaList.vue?vue&type=script&lang=js&"
export * from "./CobrancaList.vue?vue&type=script&lang=js&"
import style0 from "./CobrancaList.vue?vue&type=style&index=0&id=46d2bb18&lang=scss&scoped=true&"
import style1 from "./CobrancaList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d2bb18",
  null
  
)

export default component.exports